module.exports = __webpack_public_path__ + "static/media/mask.d260aed7.png";